import api from './api';

/**
 * Obtiene el estado completo de un juego desde el backend.
 * @param {string} gameId - El ID del juego a obtener.
 * @returns {Promise<object>} El payload de datos de la respuesta (DTO.data).
 */
export const getGame = async (gameId) => {
  if (!gameId)
    {
      console.warn("[getGame] gameId is undefined or null");
      return null;
    } 

  // El interceptor de Axios ya se encarga de devolver `response.data`
  const response = await api.get(`/api/games/${gameId}`);
  //console.info("[getGame] response:", response);
  return response.data;
};

// ... (el resto de tus funciones de API como createGame, etc., no cambian)
export const createPlayer = async (playerName) => {
    const response = await api.post('/api/players', { name: playerName });
    return response.player;
};

export const createGame = async (gameData) => {
    const response = await api.post('/api/games', gameData);
    return response.data.game;
};

export const getGamesForPlayer = async (playerId) => {
    const response = await api.get(`/api/games?player_id=${playerId}`);
    return response.data.games || [];
};

export const deployUnitApi = (gameId, unitId, x, y) => {
  return api.post(`/api/games/${gameId}/deploy`, { 
    unit_id: unitId, 
    x, 
    y 
  });
};

export const finalizeDeploymentApi = async (gameId) => { // 1. Mark the function as async
  //console.info("[finalizeDeploymentApi] Finalizing deployment for game:", gameId);
  try {
    const response = await api.post(`/api/games/${gameId}/finalize-deployment`);
    //console.info("[finalizeDeploymentApi] Response received:", response);
    return response.data; // 2. Return the data directly
  } catch (error) {
    console.error("[finalizeDeploymentApi] API call failed:", error);
    throw error;
  }
};

/**
 * Notifica al backend que el jugador ha finalizado su fase de planificación.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} La respuesta de la API.
 */
export const finalizePlanningApi = async (gameId) => { // ✅ 1. Marcar la función como async
  if (!gameId) {
    console.error("[finalizePlanningApi] gameId no puede ser nulo.");
    return Promise.reject(new Error("gameId is required"));
  }
  
  // Usamos el 'api' (instancia de Axios) que ya se encarga de las cabeceras y el token CSRF.
  try {
    // ✅ 2. Usar await para esperar la respuesta del servidor.
    const response = await api.post(`/api/games/${gameId}/finalize-planning`);
    
    // ✅ 3. Ahora 'response' es el objeto de respuesta real.
    // Devolvemos la respuesta completa para que el componente decida qué usar.
    return response.data; 
  } catch (error) {
    // Es una buena práctica manejar el error aquí y relanzarlo.
    console.error("[finalizePlanningApi] La llamada a la API falló:", error);
    throw error;
  }
};

// en frontend/src/api/gameApi.js

// ... (tus otras funciones como finalizePlanningApi)
export const executeResolutionApi = (gameId) => {
  // console.log(`[gameApi] Calling execute-resolution for game: ${gameId}`);
  return api.post(`/api/games/${gameId}/execute-resolution`);
};

/**
 * ✅ NUEVA FUNCIÓN
 * Confirma que el jugador ha visto la cinemática para avanzar al siguiente turno.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} La respuesta de la API.
 */
export const confirmResolutionViewedApi = (gameId) => {
  console.log(`[gameApi] Calling confirm-resolution for game: ${gameId}`);
  return api.post(`/api/games/${gameId}/confirm-resolution`);
};

/**
 * Continue to next turn after resolution
 * @param {string} gameId - The game ID
 * @returns {Promise<object>} The API response
 */
export const continueToNextTurnApi = (gameId) => {
  console.log(`[gameApi] Calling continue-turn for game: ${gameId}`);
  return api.post(`/api/games/${gameId}/continue-turn`);
};